	angular
	  .module('vppApp')
	  .service('VarientService', VarientService);

		VarientService.$inject = ['$rootScope'];

		function VarientService($rootScope) {
			var varientInfoService = {};
			$rootScope.varientData = {};

	    var _createVarientObj = function (varientInf) {
			 $rootScope.varientData = {
        		varient: varientInf
        };
		 };
     // Recreate data Obj for page refresh
      var _reCreateVarientObj = function (varientInf) {
        $rootScope.varientData = {
        		varient: varientInf
        };
      };
		 // varientInfoService.destroyVarient = function() {
   //    window.localStorage.removeItem("vppDataVarient");
   //    window.sessionStorage.removeItem('vppDataVarient');
	  //   $rootScope.varientData = {};

	  // };
	  varientInfoService.addVarient = function(varientInf) {
	    // create userObj from success 
	    _createVarientObj(varientInf);
	    // sets localStorage data
	    window.localStorage["vppDataVarient"] = angular.toJson($rootScope.varientData);
	    // sets sessionStorage data
	    window.sessionStorage["vppDataVarient"] = angular.toJson($rootScope.varientData);
	  };
	  varientInfoService.getVarientName = function() {
	    var _varientCode = $rootScope.varientData.varient;
	    return _varientCode;
	  };

	  varientInfoService.checkVarientExists = function () {
		 if (Object.keys($rootScope.varientData).length === 0) {
			 // $rootScope.vppDataVarient is Empty
			 var _tempSVNData = angular.fromJson(window.sessionStorage.getItem("vppDataVarient"));
			 var _tempLVNData = angular.fromJson(window.localStorage.getItem("vppDataVarient"));

			 if (_tempSVNData && _tempLVNData) {
					_reCreateVarientObj(_tempLVNData.varient);
			 } 
			 // end
		 }

	 };

	  return varientInfoService;


	};





